window.process = window.process || {
    env: {
      NODE_ENV: "production",
    },
  };